<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Quick Links"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="update" class="btn btn--primary btn--primary--sml" v-if="checkPermission('quicklinks', 'edit')">Save Changes</app-button>
                </div>
            </div>

            <app-tabs-wrapper default="link" :loading="loading" :initial="loading" class="mb-8" v-if="checkPermission('quicklinks', 'edit')">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="link" :handle-click="toggle" :active="active" >Link</app-tabs-trigger>
                    <app-tabs-trigger name="page" :handle-click="toggle" :active="active">Page</app-tabs-trigger>
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="link" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    v-for="(l, i) in items.locales"
                                    :key="i"
                                    :required="true"
                                    :label="l.lang+' Title'"
                                    v-model="fields.titles[l.id]"
                                    :error="errors.titles"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    v-for="(l, i) in items.locales"
                                    :key="i"
                                    :required="true"
                                    :label="l.lang+' Slug'"
                                    v-model="fields.slugs[l.id]"
                                    :error="errors.slugs"
                                />
                            </div>
                        </div>

                        <app-field-toggle
                            :required="false"
                            label="Display on animation?"
                            v-model="fields.animate"
                            :error="errors.animate"
                        />

                        <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save('link')">
                            <span v-if="editing.index === false">Add</span>
                            <span v-else>Save</span>
                        </app-button>
                        <app-button v-if="editing.index !== false" element="a" class="btn  btn--secondary  btn--secondary--sml ml-1" @click="cancel">
                            Cancel
                        </app-button>
                    </app-tabs-content>

                    <app-tabs-content name="page" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    v-for="(l, i) in items.locales"
                                    :key="i"
                                    :required="true"
                                    :label="l.lang+' Title'"
                                    v-model="fields.titles[l.id]"
                                    :error="errors.titles"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-select
                                    :required="true"
                                    label="Page"
                                    :items="selects.pages"
                                    v-model="fields.page_id"
                                    preselect="&mdash; Please select page &mdash;"
                                    :error="errors.page_id"
                                />
                            </div>
                        </div>

                        <app-field-toggle
                            :required="false"
                            label="Display on animation?"
                            v-model="fields.animate"
                            :error="errors.animate"
                        />

                        <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save('page')">
                            <span v-if="editing.index === false">Add</span>
                            <span v-else>Save</span>
                        </app-button>
                        <app-button v-if="editing.index !== false" element="a" class="btn  btn--secondary  btn--secondary--sml ml-1" @click="cancel">
                            Cancel
                        </app-button>
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('quicklinks', 'view')">
                <app-table v-if="quicklinks.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Titles
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Page
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                URL
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Display on animation?
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(q, i) in quicklinks" :key="i">
                            <app-table-cell>
                                <span v-for="(l, i) in locales" v-if="q.titles[l.id] != 'undefined' && q.titles[l.id] != ''">
                                    <strong>{{ l.lang }}:</strong> {{ q.titles[l.id] }}<br />
                                </span>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <span v-if="q.page_id != '' && q.type == 'page'">
                                    {{ items.pages[q.page_id] }}
                                </span>
                                <span v-else>
                                    N/A
                                </span>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <span v-for="(l, i) in locales" v-if="q.type == 'link' && typeof q.slugs != 'undefined' && q.slugs !== null && typeof q.slugs[l.id] != 'undefined' && q.slugs[l.id] != ''">
                                    <strong>{{ l.lang }}:</strong> {{ q.slugs[l.id] }}<br />
                                </span>
                                <span v-else>
                                    N/A
                                </span>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <app-icon :icon="q.animate ? 'check-circle' : 'times-circle'" :class="{'text-green': q.animate, 'text-red': !q.animate, 'text-lg': true}" />
                            </app-table-cell>
                            <app-table-cell>
                                <a href="#" class="mr-2 text-blue hover:text-blue-darker" @click="edit($event, i)" v-if="checkPermission('quicklinks', 'edit')">
                                    <app-icon icon="edit" />
                                </a>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="remove($event, i)" v-if="checkPermission('quicklinks', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <div v-if="quicklinks.length <= 0">
                    <p>No quicklinks have been added.</p>
                </div>
            </app-box>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';

    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CategoryField from '@/components/fields/inputs/Category';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import TrixField from '@/components/fields/inputs/Trix';
    import CurrencyField from '@/components/fields/inputs/Currency';
    import RepeatableField from '@/components/fields/inputs/Repeatable';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'services.home',

        data: () => ({
            loading: true,
            response: null,
            errors: {},
            editing: {
                index: false,
                type: ''
            },
            fields: {
                titles: {},
                slugs: {},
                page_id: '',
                animate: false
            },
            quicklinks: [],
            selects: {
                pages: []
            },
            items: {
                pages: [],
                locales: []
            }
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-category': CategoryField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-trix': TrixField,
            'app-field-currency': CurrencyField,
            'app-field-repeatable': RepeatableField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent
        },

        mounted() {
            this.getPages().then(response => {
                return this.getLocales();
            })
            .then(response => {
                return this.getQuicklinks();
            })
            .then(response => {
                this.loading = false;
            });
        },

        methods: {
            getLocales() {
                return Api.request('get', `quicklinks/locales`)
                    .then(({ data }) => {
                        this.items.locales = data.locales;

                        for(let key in data.locales) {
                            this.fields.titles[data.locales[key].id] = '';
                            this.fields.slugs[data.locales[key].id] = '';
                        }
                    });
            },

            getPages() {
                return Api.request('get', `quicklinks/pages`)
                    .then(({ data }) => {
                        this.items.pages = data.pages;

                        for(let key in data.pages) {
                            this.selects.pages.push({
                                label: data.pages[key],
                                value: key
                            });
                        }
                    });
            },

            getQuicklinks() {
                return Api.request('get', `quicklinks`)
                    .then(({ data }) => {
                        this.quicklinks = data.quicklinks;
                        this.response = data;
                    });
            },

            save(type) {
                event.preventDefault();

                this.loading = true;

                let link = {
                    type: type
                };

                for(let key in this.fields) {
                    if(typeof this.fields[key] !== 'object') {
                        link[key] = this.fields[key];
                    } else {
                        link[key] = {};
                        for(let index in this.fields[key]) {
                            link[key][index] = this.fields[key][index];
                        }
                    }
                }

                if(this.editing.index !== false) {
                    this.quicklinks[this.editing.index] = link;
                } else {
                    this.quicklinks.push(link);
                }

                setTimeout(() => {
                    this.loading = false;
                    this.resetFields();
                    this.resetEditing();
                }, 500);
            },

            resetFields() {
                this.fields.page_id = '';
                this.fields.animate = false;

                for(let key in this.fields.titles) {
                    this.fields.titles[key] = '';
                    this.fields.slugs[key] = '';
                }
            },

            resetEditing() {
                this.editing.index = false;
                this.editing.type = '';
            },

            edit(event, index) {
                event.preventDefault();

                this.loading = true;

                if(typeof this.quicklinks[index] !== 'undefined') {
                    this.editing.index = index;
                    this.editing.type = this.quicklinks[index].type;

                    for(let key in this.quicklinks[index]) {
                        if(key != 'type' && typeof this.quicklinks[index][key] != 'object') {
                            this.fields[key] = this.quicklinks[index][key];
                        } else if(key != 'type' && typeof this.quicklinks[index][key] == 'object') {
                            for(let i in this.quicklinks[index][key]) {
                                this.fields[key][i] = this.quicklinks[index][key][i];
                            }
                        }
                    }
                }

                setTimeout(() => {
                    this.loading = false;
                }, 500);
            },

            cancel() {
                this.loading = true;

                this.resetEditing();
                this.resetFields();

                setTimeout(() => {
                    this.loading = false;
                }, 500);
            },

            remove(event, index) {
                event.preventDefault();

                this.loading = true;

                this.quicklinks.splice(index, 1);

                setTimeout(() => {
                    this.loading = false;
                }, 500);
            },

            update() {
                this.loading = true;

                return Api.request('post', `quicklinks/create`, {
                    quicklinks: this.quicklinks
                }).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'quicklinks.home'
                        });
                    }
                })
                .then(response => {
                    this.loading = false;
                });
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/quicklinks/Home.vue